import { gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { CustomEase } from "gsap/CustomEase";

document.addEventListener("DOMContentLoaded", function() {

  (function factsModule() {

    const sliderContainer = document.querySelector(".hkbis-facts-module-animation");

    if (sliderContainer) {

      const titleSliderContainer = sliderContainer.querySelector(".hkbis-facts-module-animation .block__hkbis-facts-module__title-container");
      const titleSlides = sliderContainer.querySelectorAll(".hkbis-facts-module-animation .block__hkbis-facts-module__title-container > div");
      const imageSliderContainer = sliderContainer.querySelector(".hkbis-facts-module-animation .block__hkbis-facts-module__img-container");
      const textSliderContainer = sliderContainer.querySelector(".hkbis-facts-module-animation .block__hkbis-facts-module__text-container");
      const buttonContainer = sliderContainer.querySelector(".hkbis-facts-module-animation .block__hkbis-facts-module__nav-button-container");


      if (titleSliderContainer && textSliderContainer && imageSliderContainer && buttonContainer) {

        const buttonSVG = buttonContainer.children[0];

        let currentSlide = 0;
        const numberOfSlides = imageSliderContainer.children.length;

        if (numberOfSlides > 1) {

          const duration = 0.7;

          const containerExtendPercent = numberOfSlides.toString() + '00%';

          const changeValuePercent = (1 / numberOfSlides * 100);
          const changeValuePercentString = changeValuePercent.toString();

          const changeValuePercentNegative = (100 - changeValuePercent);
          const changeValuePercentNegativeString = changeValuePercentNegative.toString();

          const animationOptions = {ease: CustomEase.create("custom", "M0,0 C0.62,-0.408 0.676,0.716 1,1 "), duration: duration};

          const buttonColors = [
            ["bg-classic-primary80", "bg-dark-grey-dark", "bg-pride-sky", "bg-pastel-turquoise-light"],
            ["bg-classic-primary80", "bg-dark-grey-dark", "bg-pride-lemon", "bg-pastel-lemon-light"],
            ["bg-classic-primary80", "bg-dark-grey-dark", "bg-pride-violet", "bg-pastel-indigo-light"],
          ];

          buttonColors[0].forEach(c => buttonContainer.classList.add(c));

          let activeButton = true;

          buttonContainer.addEventListener('click', function() {
            if (activeButton) {
              activeButton = false;
              currentSlide = animateSlide(currentSlide);
              setTimeout(() => {
                activeButton = true;
              }, duration * 1000)
            }
          });

          const sizeSlider = () => {
            ScrollTrigger.matchMedia({
              "(min-width: 0px) and (max-width: 767px)": function () {

                titleSliderContainer.style.minWidth = containerExtendPercent;
                gsap.set(titleSliderContainer, {x: '-' + changeValuePercentNegativeString + '%'});
                imageSliderContainer.style.minWidth = containerExtendPercent;
                textSliderContainer.style.minWidth = containerExtendPercent;

              },
              "(min-width: 768px)": function () {

                let maxHeight = 0;

                titleSlides.forEach(slide => {
                  slide.style.height = 'unset';
                  const slideHeight = slide.getBoundingClientRect().height;
                  if(slideHeight >= maxHeight) {
                    maxHeight = slideHeight
                  }
                });

                titleSlides.forEach(slide => {
                  slide.style.height = maxHeight.toString() + 'px';
                });

                titleSliderContainer.style.minHeight = containerExtendPercent;
                gsap.set(titleSliderContainer, {y: '-' + changeValuePercentNegativeString + '%'});
                gsap.set(titleSliderContainer, {marginBottom: (-1 * ( (numberOfSlides - 1) / numberOfSlides ) * titleSliderContainer.getBoundingClientRect().height)});
                imageSliderContainer.style.minHeight = containerExtendPercent;
                textSliderContainer.style.minWidth = containerExtendPercent;

              },
            });
          }

          sizeSlider();
          window.addEventListener('resize', function() {
            sizeSlider();
          });

          function animateSlide(slideIndex) {

            let nextSlide = (slideIndex + 1 === numberOfSlides) ? 0 : (slideIndex + 1);
            buttonColors[slideIndex % 3].forEach(c => buttonContainer.classList.remove(c));
            buttonColors[nextSlide % 3].forEach(c => buttonContainer.classList.add(c));

            let lastAnimation = false;
            if (slideIndex + 1 === numberOfSlides) {
              lastAnimation = true;
            }

            if (slideIndex + 2 === numberOfSlides) {
              gsap.to( buttonSVG, {rotation: "180", ...animationOptions});
            } else {
              gsap.to( buttonSVG, {rotation: "0", ...animationOptions});
            }

            ScrollTrigger.matchMedia({
              "(min-width: 0px) and (max-width: 767px)": function () {
                if (lastAnimation) {
                  gsap.to(imageSliderContainer, {x: 0, ...animationOptions});
                  gsap.to(titleSliderContainer, {x: '-' + changeValuePercentNegativeString + '%', ...animationOptions});
                  gsap.to(textSliderContainer, {x: 0, ...animationOptions});
                } else {
                  gsap.to(imageSliderContainer, {x: "-=" + changeValuePercentString + "%", ...animationOptions});
                  gsap.to(titleSliderContainer, {x: "+=" + changeValuePercentString + "%", ...animationOptions});
                  gsap.to(textSliderContainer, {x: "-=" + changeValuePercentString + "%", ...animationOptions});
                }
              },
              "(min-width: 768px)": function () {
                if (lastAnimation) {
                  gsap.to(imageSliderContainer, {y: 0, ...animationOptions});
                  gsap.to(titleSliderContainer, {y: '-' + changeValuePercentNegativeString + '%', ...animationOptions});
                  gsap.to(textSliderContainer, {x: 0, ...animationOptions});
                } else {
                  gsap.to(imageSliderContainer, {y: "-=" + changeValuePercentString + "%", ...animationOptions});
                  gsap.to(titleSliderContainer, {y: "+=" + changeValuePercentString + "%", ...animationOptions});
                  gsap.to(textSliderContainer, {x: "-=" + changeValuePercentString + "%", ...animationOptions});
                }
              },
            });
            if (slideIndex + 1 === numberOfSlides) {
              return 0;
            } else {
              return ++slideIndex;
            }
          }
        }
      }
    }
  })();
});
